// @owners { team: patient-fulfillment }
export const closeCart = () => ({
  type: 'CLOSE_CART' as const,
});

export const openCart = () => ({
  type: 'OPEN_CART' as const,
});
